
import { defineComponent, onMounted, ref, inject, computed } from "vue";
import { useToast } from "vue-toastification";

import InputLabel from "@/components/atoms/InputLabel.vue";

// services
import emailService from "@/services/email.service";
import { AxiosError } from "axios";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  components: {
    InputLabel,
  },
  setup() {
    const toast = useToast();
    const router = useRouter();
    const route = useRoute();
    const setPageTitle = inject("setPageTitle") as CallableFunction;
    const setIsLoading = inject("setIsLoading") as CallableFunction;
    onMounted(() => setPageTitle("Customize Email"));

    // get email template
    const name = ref<string>("");
    const header = ref<string>("");
    const body = ref<string>("");
    const defaultBody = ref<string>("");

    const emailTemplateIdParam = String(route.query.email_template_id);

    onMounted(async () => {
      setIsLoading(true);

      if (!emailTemplateIdParam) {
        toast.error("Email template tidak boleh kosong");
        goBack();
        return;
      }

      try {
        const { data } = await emailService.getEmailTemplate(
          emailTemplateIdParam
        );

        name.value = data.name;
        header.value = data.subject;
        body.value = data.body;
        defaultBody.value = data.default_body;

        setIsLoading(false);
      } catch (e) {
        console.error(e);
        toast.error("Email template tidak ditemukan");
        goBack();
        return;
      }
    });

    const EMPTY_BODY = "<p><br></p>";
    const canSubmit = computed(
      () => header.value && body.value && body.value !== EMPTY_BODY
    );
    const reset = () => {
      body.value = defaultBody.value;
    };

    const goBack = () => {
      router.go(-1);
    };

    const saveEmail = async () => {
      try {
        setIsLoading(true);
        const req = {
          name: name.value,
          subject: header.value,
          body: body.value,
        };

        await emailService.updateEmailTemplate(emailTemplateIdParam, req);
        setIsLoading(false);

        const reqQueries = route.query;
        const projectId = Number(route.params.projectId);
        router.push({
          path: `/admin/project/${projectId}/invite/confirmation`,
          query: reqQueries,
        });
      } catch (e) {
        console.error(e);
        let errMsg = (e as AxiosError).response?.data?.error || "Ada kesalahan";
        toast.error(errMsg);
      }
    };

    return {
      name,
      header,
      body,
      canSubmit,
      reset,
      goBack,
      saveEmail,
    };
  },
});
